import React from 'react';
import ReactDOM from 'react-dom';

import './index.scss';

import {
    BrowserRouter as Router,
    Route,
    Routes
} from "react-router-dom";

import sdk from "scoutli-sdk"

import Landing from "./pages/Landing";
import _Pricing from "./pages/Pricing";
import Product from "./pages/Product";
import About from "./pages/About";
import Support from "./pages/Support";
import ForgotPassword from "./pages/ForgotPassword";
import _NotFound from "./pages/NotFound";
import Terms from "./pages/Terms";
import _Thanks from "./pages/Thanks";
import _Error from "./pages/Error";
import GetStarted from "./pages/GetStarted";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Scrims from "./pages/Scrims";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Logout from "./pages/Logout";
import ChangePassword from "./pages/ChangePassword";
import Page from "./pages/Page";
import Analytics from "./pages/Analytics";
import Gamebar from "./components/Gamebar";

const main = async () => {
    let accessToken = localStorage.getItem("accessToken");

    let loggedIn = false

    if (accessToken) {
        const user = await sdk.user(accessToken).get.userData().catch(() => {
            localStorage.removeItem("accessToken")
        })

        if (user) {
            loggedIn = true
        }
    }

    ReactDOM.render(
        <React.StrictMode>
            <Router>
                <Routes>
                    <Route path="*" element={<_NotFound/>}/>

                    {loggedIn && (
                        <Route path="/" element={<Dashboard/>}/>
                    )}

                    {!loggedIn && (
                        <Route path="/" element={<Landing/>}/>
                    )}

                    <Route path="/product" element={<Page content={<Product/>}/>}/>
                    <Route path="/pricing" element={<Page content={<_Pricing/>}/>}/>
                    <Route path="/about" element={<Page content={<About/>}/>}/>
                    <Route path="/support" element={<Page content={<Support/>}/>}/>
                    <Route path="/forgot-password" element={<Page content={<ForgotPassword/>}/>}/>
                    <Route path="/thanks" element={<Page content={<_Thanks/>}/>}/>

                    <Route path="/get-started" element={<GetStarted/>}/>
                    <Route path="/login" element={<Login/>}/>

                    <Route path="/change-password" element={<ChangePassword/>}/>

                    <Route path="/scouting" element={<Dashboard title="Scouting"/>}/>
                    <Route path="/calendar" element={<Dashboard title="Calendar"/>}/>
                    <Route path="/scrims" element={<Dashboard title="Scrims" content={<Scrims/>}/>}/>
                    <Route path="/financial" element={<Dashboard title="Financial"/>}/>
                    <Route path="/data" element={<Dashboard title="Player Data"/>}/>
                    <Route path="/reports" element={<Dashboard title="Reports" content={<Reports/>}/>}/>
                    <Route path="/jobs" element={<Dashboard title="Job Board"/>}/>
                    <Route path="/social" element={<Dashboard title="Social Feed"/>}/>
                    <Route path="/fantasy" element={<Dashboard title="Fantasy League"/>}/>
                    <Route path="/challenge" element={<Dashboard title="Pick'em Challenge"/>}/>
                    <Route path="/analytics" element={<Dashboard extra={<Gamebar/>} title="Analytics" content={<Analytics/>}/>}/>
                    <Route path="/settings" element={<Dashboard title="Settings" content={<Settings/>}/>}/>
                    <Route path="/notifications" element={<Dashboard title="Notifications"/>}/>

                    <Route path="/logout" element={<Logout/>}/>
                    <Route path="/error" element={<_Error/>}/>
                    <Route path="/terms" element={<Terms/>}/>
                </Routes>
            </Router>
        </React.StrictMode>,
            document.getElementById('root')
    );
}

main()